// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"647":"8b9a4c8c","673":"10a7ba48","714":"5def2cc1"}[chunkId] + ".chunk.css";
};